import { StatusChipColor } from "components/StatusChip";
import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import { StateWasteStreamRegistrationStatus } from "generated-graphql/graphql";

// IN_PROGRESS collides with the "IN" (Indiana) state-abbreviation heuristic in
// the default enum pretty-printer, so this enum opts out of it (see
// FilterKey.ignoreStateAbbreviations for the write-up).
export function statusLabel(status: StateWasteStreamRegistrationStatus): string {
  return prettyPrintEnumValue(status, undefined, true);
}

// Semantic StatusChip roles for each registration status. Routed through
// StatusChip so the pill follows the design-system chip spec instead of MUI's
// solid dark-fill default.
export const STATUS_COLOR: Record<StateWasteStreamRegistrationStatus, StatusChipColor> = {
  [StateWasteStreamRegistrationStatus.Registered]: "success",
  [StateWasteStreamRegistrationStatus.InProgress]: "info",
  [StateWasteStreamRegistrationStatus.Closed]: "default",
};
